import React from 'react';
import classnames from 'classnames';
import { format } from 'timeago.js';

import TweetAuthor from '../TweetAuthor/';
import TweetText from '../TweetText/';
import TweetImage from '../TweetImage/';

import './tweet.scss';
import AppHeader from '../AppHeader';

export default ({
  item = {},
  isActive = false,
  isPrevious = false,
  isNext = false,
  config = {},
  imageActive = 0
}) => {
  const showMedia = item.media && item.media.length > 0 && config.display === 'all';
  const backgroundColor = config.style === 'bubbles' && config.bubble_color;

  return (
    <div
      className={classnames('tweet', {
        'tweet--previous': isPrevious,
        'tweet--active': isActive,
        'tweet--next': isNext,
        'tweet--has-media': showMedia,
        [`tweet--${config.animation}`]: config.animation,
        [`tweet--${config.style}`]: config.style
      })}
      style={{ color: config.text_color, backgroundColor }}
    >
      <div className="tweet__content">
        <TweetAuthor user={item.user} created={item.created_at} config={config} />
        <TweetText text={item.text} displayLinks={config.display_links} />
        {['split-screen-animated', 'split-screen-no-animation'].includes(config.style) && (
          <div className="tweet-author__created" style={{ color: config.date_color }}>
            {format(item.created_at)}
          </div>
        )}
        {['split-screen-animated', 'split-screen-no-animation'].includes(config.style) && (
          <AppHeader
            style={config.style}
            backgroundColor={config.backgroundColor}
            logoColor={config.logo_color}
          />
        )}
      </div>
      {showMedia && (
        <div className="tweet__media">
          <div className="tweet__media-content">
            {item.media.slice(0, 2).map((image, index) => {
              let imageIsActive = true;

              if (['split-screen-animated', 'split-screen-no-animation'].includes(config.style)) {
                imageIsActive = item.media.length === 1 ? true : index === imageActive;
              }

              return (
                <TweetImage
                  key={index}
                  src={image}
                  configStyle={config.style}
                  imageActive={imageIsActive}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
